const session_expired = {
    title: 'Sesión expirada',
    subtitle: 'Es posible que su sesión haya expirado y se haya desconectado. Haga clic en el botón de abajo para iniciar sesión en la consola de administración nuevamente.',
    button: 'Iniciar sesión de nuevo',
};
export default Object.freeze(session_expired);
